import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse } from "antd";
import { Dropdown, Menu } from "antd";
import { MoreOutlined, FileAddOutlined, SearchOutlined, FileDoneOutlined, EditOutlined } from "@ant-design/icons";

import TopHeader from "../../common/TopHeader/TopHeader";
import jsPDF from 'jspdf';
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import { MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import AddGoodInward from "../../common/Models/GoodInward/AddGoodInward";
import EditGoodInward from "../../common/Models/GoodInward/EditGoodInward";
import GoodInwardApi from "../../common/Apis/GoodInwardApi";
import AddStock from "../../common/Models/GoodInward/AddStock";
import SuppliersApi from "../../common/Apis/SuppliersApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const GoodInward = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const [formadd2] = Form.useForm();
  const { Panel } = Collapse;
  const [GoodInwards, setGoodInward] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [FilterEnable, setFilterEnable] = useState(true);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();

  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });


    if (FilterEnable) {
      GoodInwardApi.ListGoodInward(0, value)
        .then((response) => {
          settotalPages(response.totalPages);
          setGoodInward(response.payloadDto);
          setTotalElements(response.totalElements);

        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      let singleLineString = filterGoodInwards
        .map((obj) => {
          if (obj.answerType === "%") {
            return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
          } else if (obj.answerType === "=") {
            return `${obj.title}${obj.answerType}${obj.name}`;
          } else {
            return `${obj.title}=BETWEEN${createDateTimestamp(
              obj.answerType
            )}AND${createDateTimestamp(obj.name)}`;
          }
        })
        .join("&");

      let filderData = window.btoa(
        "componentCode=GOODS_INWARD&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
      );
      QuestionnairesApi.FilterQuestionsetNext(filderData, 0, value)
        .then((response) => {
          settotalPages(response.totalPages);
          setGoodInward(response.payloadDto);
          setTotalElements(response.totalElements);

        })
        .catch((err) => { });
    }

  };
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1


    if (FilterEnable) {
      GoodInwardApi.ListGoodInward(pageNew, PaginateLimit)
        .then((response) => {
          setPaginatePage(pageNew)
          settotalPages(response.totalPages);
          setGoodInward(response.payloadDto);
          setTotalElements(response.totalElements);

        })
        .catch((err) => {
          console.log(err);
        });

    } else {

      let singleLineString = filterGoodInwards
        .map((obj) => {
          if (obj.answerType === "%") {
            return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
          } else if (obj.answerType === "=") {
            return `${obj.title}${obj.answerType}${obj.name}`;
          } else {
            return `${obj.title}=BETWEEN${createDateTimestamp(
              obj.answerType
            )}AND${createDateTimestamp(obj.name)}`;
          }
        })
        .join("&");

      let filderData = window.btoa(
          "componentCode=GOODS_INWARD&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
      );
      QuestionnairesApi.FilterQuestionsetNext(filderData, pageNew, PaginateLimit)
        .then((response) => {
          settotalPages(response.totalPages);
          setGoodInward(response.payloadDto);
          setTotalElements(response.totalElements);

        })
        .catch((err) => { });
    }
  };
  const handlePrintButtonClick2 = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [297, 210],
    });

    const fontSize = 10;


    let yPos = 35;
    doc.setFontSize(fontSize);

    const currentDate = new Date().toLocaleDateString();
    const currentTime = new Date().toLocaleTimeString();
    const promises = [];




    for (let i = 0; i < parseInt(PaginatetotalPages); i++) {
      if (FilterEnable) {
        promises.push(
          GoodInwardApi.ListGoodInward(i, PaginateLimit).then((response) => {
            doc.setFont('Poppins', 'bold');
            doc.text(`Good Inward Process`, 150, 10, { align: 'center' });
            doc.setFont('Poppins', 'normal');
            doc.setFontSize(10);
            doc.text(`Date : ${currentDate}`, 10, 20);
            doc.text(`Time : ${currentTime}`, 10, 25);
            doc.setFontSize(fontSize);

            // Draw table headers and borders
            doc.setFont('Poppins', 'bold');
            doc.text('G.No', 15, yPos);
            doc.text('Date', 55, yPos);
            doc.text('Supplier', 85, yPos);
            doc.text('D.D.No', 120, yPos);
            doc.text('Van Condition	', 150, yPos);
            doc.text('Temperature', 180, yPos);
            doc.text('Recheck.Temp', 205, yPos);
            doc.text('Done by	', 230, yPos);
            doc.text('Remark', 250, yPos);
            doc.setFont('Poppins', 'normal');
            doc.setLineWidth(0.1);
            doc.rect(12, yPos - 5, 280, 10);
            yPos += 10;



            response.payloadDto.forEach(row => {
              const generatedNumber = row?.generatedNumber;
              const date = formatDate(row?.goodInwardCreateDate);
              const supplierName = row?.supplierDTO?.supplierName;
              const deliveryDocketNumber = row?.deliveryDocketNumber;
              const vanCondition = row?.vanCondition;
              const temperature = row?.temperature ? row?.temperature + ' °C' : "N/A";
              const createdBy = row?.tenantDTO?.createdBy;
              const temperatureRecheck = row?.temperatureRecheck ? row?.temperatureRecheck + ' °C' : "N/A";
              const allergenInfo = row?.remark;

              doc.setFontSize(fontSize);

              doc.text(generatedNumber, 15, yPos);
              doc.text(date, 55, yPos);
              doc.text(supplierName, 85, yPos);
              doc.text(deliveryDocketNumber, 120, yPos);
              doc.text(vanCondition, 150, yPos);
              doc.text(temperature, 180, yPos);
              doc.text(temperatureRecheck, 205, yPos);
              doc.text(createdBy, 230, yPos);
              const allergenLines = doc.splitTextToSize(allergenInfo, 40);
              doc.text(allergenLines, 250, yPos);

              const rowHeight = 10 * Math.max(allergenLines.length, 1);

              if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                doc.addPage();
                yPos = 35; // Reset yPos for the new page
              } else {
                doc.setLineWidth(0.1);
                doc.rect(12, yPos - 5, 280, rowHeight);
                yPos += rowHeight;
              }
            });

            if (i === parseInt(PaginatetotalPages)) {
              doc.addPage();
              yPos = 35;
            }
          }).catch((err) => {
            console.log(err);
          })
        );
      } else {

        let singleLineString = filterGoodInwards
          .map((obj) => {
            if (obj.answerType === "%") {
              return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
            } else if (obj.answerType === "=") {
              return `${obj.title}${obj.answerType}${obj.name}`;
            } else {
              return `${obj.title}=BETWEEN${createDateTimestamp(
                obj.answerType
              )}AND${createDateTimestamp(obj.name)}`;
            }
          })
          .join("&");

        let filderData = window.btoa(
            "componentCode=GOODS_INWARD&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
        );

        promises.push(
          QuestionnairesApi.FilterQuestionsetNext(filderData, i, PaginateLimit).then((response) => {
            doc.setFont('Poppins', 'bold');
            doc.text(`Good Inward Process`, 150, 10, { align: 'center' });
            doc.setFont('Poppins', 'normal');
            doc.setFontSize(10);
            doc.text(`Date : ${currentDate}`, 10, 20);
            doc.text(`Time : ${currentTime}`, 10, 25);
            doc.setFontSize(fontSize);

            // Draw table headers and borders
            doc.setFont('Poppins', 'bold');
            doc.text('G.No', 15, yPos);
            doc.text('Date', 55, yPos);
            doc.text('Supplier', 85, yPos);
            doc.text('D.D.No', 120, yPos);
            doc.text('Van Condition	', 150, yPos);
            doc.text('Temperature', 180, yPos);
            doc.text('Recheck.Temp', 205, yPos);
            doc.text('Done by	', 230, yPos);
            doc.text('Remark', 250, yPos);
            doc.setFont('Poppins', 'normal');
            doc.setLineWidth(0.1);
            doc.rect(12, yPos - 5, 280, 10);
            yPos += 10;



            response.payloadDto.forEach(row => {
              const generatedNumber = row?.generatedNumber;
              const date = formatDate(row?.goodInwardCreateDate);
              const supplierName = row?.supplierDTO?.supplierName;
              const deliveryDocketNumber = row?.deliveryDocketNumber;
              const vanCondition = row?.vanCondition;
              const temperature = row?.temperature ? row?.temperature + ' °C' : "N/A";
              const createdBy = row?.tenantDTO?.createdBy;
              const temperatureRecheck = row?.temperatureRecheck ? row?.temperatureRecheck + ' °C' : "N/A";
              const allergenInfo = row?.remark;

              doc.setFontSize(fontSize);

              doc.text(generatedNumber, 15, yPos);
              doc.text(date, 55, yPos);
              doc.text(supplierName, 85, yPos);
              doc.text(deliveryDocketNumber, 120, yPos);
              doc.text(vanCondition, 150, yPos);
              doc.text(temperature, 180, yPos);
              doc.text(temperatureRecheck, 205, yPos);
              doc.text(createdBy, 230, yPos);
              const allergenLines = doc.splitTextToSize(allergenInfo, 40);
              doc.text(allergenLines, 250, yPos);

              const rowHeight = 10 * Math.max(allergenLines.length, 1);

              if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
                doc.addPage();
                yPos = 35; // Reset yPos for the new page
              } else {
                doc.setLineWidth(0.1);
                doc.rect(12, yPos - 5, 280, rowHeight);
                yPos += rowHeight;
              }
            });

            if (i === parseInt(PaginatetotalPages)) {
              doc.addPage();
              yPos = 35;
            }
          }).catch((err) => {
            console.log(err);
          })
        );
      }

    }

    const reversedPromises = promises.map(promise =>
      promise.then(result =>
        new Promise(resolve =>
          setTimeout(() => resolve(result), 0)
        )
      )
    );

    Promise.all(reversedPromises)
      .then(() => {
        window.open(doc.output('bloburl'), '_blank');
      })
      .catch((err) => {
        console.log(err);
      });

  };
  const getGoodInward = useCallback(() => {
    GoodInwardApi.ListGoodInward(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setGoodInward(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getGoodInward();
    PageLoading();
    fetchFilterSupplier();
  }, [getGoodInward, PageLoading]);


  const handleRemovefilterGoodInwards = (FiltergetGoodInwardsIndex) => {
    const newfilterGoodInward = [...filterGoodInwards];
    newfilterGoodInward.splice(FiltergetGoodInwardsIndex, 1);
    setFilterGoodInwards(newfilterGoodInward);
    if (FiltergetGoodInwardsIndex == 0) {
      getGoodInward();
    }
  };
  const handleClear = () => {
    getGoodInward();
    setFilterEnable(true);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterGoodInwards([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterGoodInwards, setFilterGoodInwards] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterGoodInward = () => {
    setFilterGoodInwards([
      ...filterGoodInwards,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setFilterEnable(false);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterGoodInwards
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=BETWEEN${createDateTimestamp(
            obj.answerType
          )}AND${createDateTimestamp(obj.name)}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
        "componentCode=GOODS_INWARD&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setGoodInward(response.payloadDto);setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const createDateTimestamp = (Cdate) => {
    const date = new Date(Cdate);
    const unixTime = Math.floor(date.getTime());
    return unixTime;
  };
  const handleChangeTitle = (FiltergetGoodInwardsIndex, value) => {
    const newfilterGoodInward = [...filterGoodInwards];
    newfilterGoodInward[FiltergetGoodInwardsIndex].title = value;
    setFilterGoodInwards(newfilterGoodInward);
    const fieldName = 'name' + FiltergetGoodInwardsIndex;
    const fieldName2 = 'nameto' + FiltergetGoodInwardsIndex;
    formadd2.setFieldsValue({
      [fieldName]: null,
      [fieldName2]: null,
    });
  };
  const handleChangeAnswertype = (FiltergetGoodInwardsIndex, value) => {
    const newfilterGoodInward = [...filterGoodInwards];
    newfilterGoodInward[FiltergetGoodInwardsIndex].answerType = value;
    setFilterGoodInwards(newfilterGoodInward);
  };
  const handleChangeAnswertypeFilter = (FiltergetproductionIndex, value) => {
    const newfilterProduction = [...filterGoodInwards];
    newfilterProduction[FiltergetproductionIndex].answerType = '=';
    newfilterProduction[FiltergetproductionIndex].name = value;
    setFilterGoodInwards(newfilterProduction);
  };
  const handleChangename = (FiltergetGoodInwardsIndex, value) => {
    const newfilterGoodInward = [...filterGoodInwards];
    newfilterGoodInward[FiltergetGoodInwardsIndex].name = value;
    setFilterGoodInwards(newfilterGoodInward);
  };

  const paginatedData = GoodInwards;
  function convertToAMPM(time) {
    const timeNew = parseInt(time, 10);
    const options = { hour: "2-digit", minute: "2-digit" };
    const formattedTime = new Date(timeNew).toLocaleTimeString(
      "en-US",
      options
    );

    return formattedTime;
  }

  // Handle Edit Modal
  const handleOpenEditModal = (GoodInwardID) => {
    GoodInwardApi.SingleGoodInward(GoodInwardID)
      .then((response) => {
        setModalEditData(response.payload);
        setModalEditVisible(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item?.id} className="text-center">
          <td style={{ width: "22%" }} className="pt-3">
            {item?.generatedNumber}
          </td>
          <td style={{ width: "12%" }} className="pt-3">
            {item?.goodInwardCreateDate
              ? formatDate(item?.goodInwardCreateDate)
              : ""}
          </td>
          <td style={{ width: "10%" }} className="pt-3">
            {convertToAMPM(item?.createdDate)}
          </td>
          <td style={{ width: "10%" }} className="pt-3">
            {item?.supplierDTO?.supplierName}
          </td>
          <td style={{ width: "10%" }} className="pt-3">
            {item?.deliveryDocketNumber}
          </td>
          <td style={{ width: "10%" }} className="pt-3">
            {item?.vanCondition}
          </td>
          <td style={{ width: "10%" }} className="pt-3 text-center">
            {item?.temperature ? item?.temperature + ' °C' : "N/A"}
          </td>
          <td style={{ width: "10%" }} className="pt-3 text-center">
            {item?.temperatureRecheck ? item?.temperatureRecheck + ' °C' : "N/A"}
          </td>
          <td style={{ width: "10%" }} className="pt-3 text-center">
            {item?.remark &&
              <Tooltip placement="top" title={(
                <div>
                  {item?.remark}
                </div>
              )}>
                <FileDoneOutlined className="inforIcon" />
              </Tooltip>
            }
          </td>
          <td style={{ width: "10%" }} className="pt-3 text-center">
            {item?.createdBy}
          </td>

          <td style={{ width: "10%" }}>
            <div className="d-flex justify-content-center">
              <Dropdown
                overlay={
                  <Menu
                    style={{ width: "99%" }}
                  >
                    <Menu.Item
                      key="edit"
                      className={decodedToken?.permissions?.some(
                        (permission) => permission?.authority === 'EDIT_GOODS_INWARD'
                      ) ? '' : 'd-none'}
                      onClick={() => handleOpenEditModal(item.id)}
                    >
                      <EditOutlined /> Edit
                    </Menu.Item>
                    <Menu.Item
                      key="stock"
                      onClick={() => handleOpenAddStockModal(item.id)}
                    >
                      <FileAddOutlined /> Add stock
                    </Menu.Item>
                    <Menu.Item
                      style={{ whiteSpace: 'nowrap' }}
                      key="History"
                      onClick={() => OpenStock(item.deliveryDocketNumber, item?.supplierDTO?.id)}
                    >
                      <SearchOutlined /> Search History
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
                placement="bottom"
              >
                <div className="action-circle">
                  <MoreOutlined />
                </div>
              </Dropdown>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={11} className="text-center ">
            <EmptyBox />
            <br />
            <Button
              type="primary"
              onClick={handleOpenAddModal}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_GOODS_INWARD'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add Goods Inward CP1
            </Button>
          </td>
        </tr>
      );
    }
  };
  function formatDate(date) {
    const dateNew = parseInt(date, 10);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(dateNew).toLocaleDateString(
      "en-US",
      options
    );

    const [month, day, year] = formattedDate.split(" ");

    const capitalizedMonth = month.toUpperCase();

    return `${day} ${capitalizedMonth} ${year}`;
  }


  const [modalAddVisible, setModalAddVisible] = useState(false);

  const handleOpenAddModal = () => {
    setModalAddVisible(true);
  };
  const handleAddCloseModal = () => {
    setModalAddVisible(false);
  };

  const [modalAddStockVisible, setModalAddStockVisible] = useState(false);
  const [modalEditData, setModalEditData] = useState("");
  const [stockModalKey, setStockModalKey] = useState(0);
  
  const handleOpenAddStockModal = (GoodInwardID) => {
    GoodInwardApi.SingleGoodInward(GoodInwardID)
      .then((response) => {
        setModalEditData(response.payload);
        setModalAddStockVisible(true);
        setStockModalKey(prev => prev + 1);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleAddStockCloseModal = () => {
    setModalAddStockVisible(false);
  };

  const handleContinueStock = () => {
      setModalAddStockVisible(false);
    // Reopen after a small delay with a new key to force remount
    setTimeout(() => {
      setStockModalKey(prev => prev + 1);
      setModalAddStockVisible(true);
    }, 100);
    };

  const OpenStock = (productId, supplier_id) => {
    return navigate('/stock?invoice_id=' + productId + '&supplier_id=' + supplier_id);
  };

  const [modalEditVisible, setModalEditVisible] = useState(false);


  const handlEditeCloseModal = () => {
    setModalEditVisible(false);
    getGoodInward(); // Refresh the list after edit
  };


  const [FilterSuppliers, setFilterSuppliers] = useState([]);
  const [TotalPageNew, setTotalPageNew] = useState(null);
  const [page, setPage] = useState(0);


  const fetchFilterSupplier = async () => {
    try {
      SuppliersApi.Listsuppliers(page, 10)
        .then((response) => {
          setTotalPageNew(response.totalPages);
          setFilterSuppliers(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

          setPage(prevPage => prevPage + 1);

        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
    } finally {
    }
  };
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
    if (bottom || nearBottom) {
      if (TotalPageNew > page) {
        fetchFilterSupplier();
      }
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader onPrintResponse2={handlePrintButtonClick2} />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            form={formadd2}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterGoodInwards.map((input, filterGoodInwardsIndex) => (
                    <div key={filterGoodInwardsIndex}>
                      <Row gutter={24} className="pt-2">
                        <Col lg={5} md={5} className="px-1">
                          <Form.Item
                            name={`title${filterGoodInwardsIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterGoodInwardsIndex, value)
                              }
                              options={[
                                {
                                  value: "generatedNumber",
                                  label: "Generated Number",
                                },
                                {
                                  value: "goodInwardCreateDate",
                                  label: "Date",
                                },
                                {
                                  value: "deliveryDocketNumber",
                                  label: "Delivery Docket Number",
                                },
                                {
                                  value: "supplier.id",
                                  label: "Supplier",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        {filterGoodInwards[filterGoodInwardsIndex].title ==
                          "goodInwardCreateDate" ? (
                          <>
                            <Col lg={4} md={4} className="px-1">
                              <Form.Item
                                name={`nameto${filterGoodInwardsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  placeholder="Filter By"
                                  onChange={(e) =>
                                    handleChangeAnswertype(
                                      filterGoodInwardsIndex,
                                      e.target.value
                                    )
                                  }
                                  className="control-input"
                                />
                              </Form.Item>
                            </Col>
                          </>
                        ) : filterGoodInwards[filterGoodInwardsIndex].title === "supplier.id" ? (
                          <>
                            <Col lg={6} md={6} className="px-1">
                              <Form.Item
                                name={`nameto${filterGoodInwardsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  className="control-Select mb-1"
                                  placeholder="Select Supplier"
                                  onPopupScroll={handleScroll}
                                  onChange={(value) =>
                                    handleChangeAnswertypeFilter(
                                      filterGoodInwardsIndex,
                                      value
                                    )
                                  }
                                  filterOption={(input, option) =>
                                    (option.props.children && option.props.children.toString().toLowerCase().includes(input.toLowerCase())) ||
                                    (option.props.children && option.props.children.toString().toLowerCase().includes(input.toLowerCase()))
                                  }
                                >
                                  {FilterSuppliers.map((option, index) => (
                                    <Select.Option key={option.id} value={option.id}>
                                      {option.supplierName} ( {option.institutionDTO?.institutionName})
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col lg={4} md={4} className="px-1">
                              <Form.Item
                                name={`type${filterGoodInwardsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterGoodInwardsIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}

                        {filterGoodInwards[filterGoodInwardsIndex].title ==
                          "goodInwardCreateDate" ? (
                          <>
                            <Col lg={5} md={5} className="px-1">
                              <Form.Item
                                name={`name${filterGoodInwardsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select End Date.",
                                  },
                                ]}
                              >
                                <Input
                                  type="date"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterGoodInwardsIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </Col>
                          </>
                        ) : filterGoodInwards[filterGoodInwardsIndex].title === "supplier.id" ? (
                          <>

                          </>
                        ) : (
                          <>
                            <Col lg={5} md={5} className="px-1">
                              <Form.Item
                                name={`name${filterGoodInwardsIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterGoodInwardsIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}


                        <Col lg={8} md={10} className="px-1">
                          <Form.Item className="text-lable">
                            {filterGoodInwardsIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterGoodInward}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterGoodInwards(
                                      filterGoodInwardsIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                {paginatedData?.length > 0 && (
                  <Button
                    type="primary"
                    onClick={handleOpenAddModal}
                    style={{
                      display: decodedToken?.permissions?.some(
                        permission => permission?.authority === 'ADD_GOODS_INWARD'
                      ) ? '' : 'none',
                      height: 'auto',
                      lineHeight: 'normal',
                      alignItems: 'center',
                      padding: '5px 24px',
                    }}
                  >
                    Add Goods Inward CP1
                  </Button>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>G.No</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Supplier</th>
                  <th>D.D.No</th>
                  <th>Van Condition</th>
                  <th>Temperature</th>
                  <th>Recheck.Temp</th>
                  <th className="text-center">Remark</th>
                  <th className="text-center">Done by	</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}              
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>

        {modalAddVisible && <AddGoodInward
          visible={modalAddVisible}
          onClose={handleAddCloseModal}
        />
        }
        {modalEditVisible && <EditGoodInward
          visible={modalEditVisible}
          onClose={handlEditeCloseModal}
          GoodInward={modalEditData}
        />
        }
        {modalAddStockVisible && <AddStock
          key={stockModalKey}
          visible={modalAddStockVisible}
          onClose={handleAddStockCloseModal}
          onContinue={handleContinueStock}
          ProductDetails={modalEditData}
        />
        }
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default GoodInward;